export const dashboard_base ="https://vger.udel.edu/views/ResearchDashboard-web-demo-11-18-2022/"


// WEBPACK FOOTER //
// ./src/pages/Setting.tsx